import clsx from "clsx";
import type { ElementGroupScrollableDivideListProps } from "./types";

export const ElementGroupScrollableDivideList = ({
  containerRef,
  children,
  className,
}: ElementGroupScrollableDivideListProps) => {
  return (
    <div
      className={clsx("flex-1 min-h-0 overflow-y-auto", className)}
      ref={containerRef}
    >
      <ul className="divide-y divide-gray-200">{children}</ul>
    </div>
  );
};
